import FlightEntryPagination from './FlightEntryPagination';

export default FlightEntryPagination;
